import { STARTING_NODE_INDEX } from 'src/stores/flowStore';
import router from 'src/router';
import { NODE_ROUTE } from 'src/config/routes';
import appConfig from 'src/utils/appConfig';
import getFlow from 'src/libs/flowService/getFlow';
import { shouldAbTesterBeUsed } from 'src/router/queryString';
import initializer from './initializer';
import { LANGUAGE_SELECTION_FLOW_ID } from 'src/config/flowConfig';
import {
  isLearnLanguageValid,
  DEFAULT_LEARN_LANGUAGE,
  ENGLISH_LOCALES,
  ENGLISH_DEFAULT_LEARN_LANGUAGE
} from 'src/config/languages';
import invalidLocaleRedirect from './invalidLocaleRedirect';

const getValidLearnLanguage = ({ learningLanguage }) => {
  const { locale } = appConfig.serialize();
  if (isLearnLanguageValid(learningLanguage)) return learningLanguage;
  if (ENGLISH_LOCALES.includes(locale)) return ENGLISH_DEFAULT_LEARN_LANGUAGE;
  return DEFAULT_LEARN_LANGUAGE;
};

const getValidNodeId = (downloadedFlow, { flowId, nodeId }) =>
  (downloadedFlow.id === flowId && nodeId) ? nodeId : STARTING_NODE_INDEX;

const getValidParams = (downloadedFlow, routeParams) =>
  Object.assign({}, routeParams, {
    flowId: downloadedFlow.id,
    version: downloadedFlow.version,
    learningLanguage: getValidLearnLanguage(routeParams),
    nodeId: getValidNodeId(downloadedFlow, routeParams)
  });

export default ({ params }) => {
  const flowId = params.learningLanguage ? params.flowId : LANGUAGE_SELECTION_FLOW_ID;
  return getFlow(flowId, params.learningLanguage, shouldAbTesterBeUsed())
    .then((downloadedFlow) => {
      const validParams = getValidParams(downloadedFlow, params);
      router.replacePath(NODE_ROUTE, validParams);
      invalidLocaleRedirect(downloadedFlow.locales);
      initializer.initialize(validParams, downloadedFlow);
    });
};
